/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * SolutionStatusDtoBase
 * auto generated base class for the model SolutionStatusDtoModel.
 */
export const SolutionStatusDtoModelBase = ModelBase
  .named('SolutionStatusDto')
  .props({
    __typename: types.optional(types.literal("SolutionStatusDto"), "SolutionStatusDto"),
    name: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SolutionStatusDtoModelSelector extends QueryBuilder {
  get name() { return this.__attr(`name`) }
}
export function selectFromSolutionStatusDto() {
  return new SolutionStatusDtoModelSelector()
}

export const solutionStatusDtoModelPrimitives = selectFromSolutionStatusDto().name
